import React from 'react';
import {History} from 'history';
import {Loading} from '../loading/loading';
import Loadable from "react-loadable";
import {lazyInject} from '../../services/container';
import {Server} from '../../services/server';
import {PageComponent, PageComponentProps} from '../pageComponent';
import DocumentTitle from 'react-document-title';
import classNames from 'classnames';
import {ClubcardSignup} from '../../models/clubcardSignup';
import successIcon from '../../assets/images/success_icon.svg';

interface SuccessPageProps extends PageComponentProps
{
    history: History;
}

export class ClubcardSuccessPage extends PageComponent<SuccessPageProps>
{
    @lazyInject(Server)
    private server: Server;
    
    private loadableComponent: any;

    public constructor(props: SuccessPageProps, context: any)
    {
        super(props, context);

        this.loadableComponent = Loadable({
            loader: () => this.server.get(null, 'clubcard-signups/current'),
            loading: loadingProps => {
                if (loadingProps.error)
                {
                    props.history.push('../');
                    return null;
                }
                else
                {
                    return <Loading />;
                }
            },
            render: (signup: ClubcardSignup, props: { history: History }) => {
                return this.renderLoaded(signup);
            }
        });
    }

    public render(): React.ReactNode
    {
        const LoadableComponent = this.loadableComponent;
        return <>
            <DocumentTitle title={this.translate.translate('clubcardSuccessPageTitle') as any as string} />
            <LoadableComponent history={this.props.history} />
        </>;
    }
    
    private renderLoaded(signup: ClubcardSignup): React.ReactNode
    {
        return <div className={classNames('nav-page', 'success-page', 'success-page-clubcard')}>
            <img className="success-icon" src={successIcon} />
            <div className="success-page-title">
                {this.translate.translate('successLine1Clubcard', { name: signup.name })}
            </div>
            <div className="top-logo-sep" />
            <div className="success-page-text">
                <div className="success-page-greeting">
                    {this.translate.translate('clubcardSuccessText')}
                </div>
                <div className="clubcard-success-code">
                    {signup.signupCode}
                </div>
            </div>
        </div>;
    }
}